<template>
  <div style>
    <v-parallax dark :height="laxheight" src="../../img/rumbleboys.jpg">
      <div class="dots">
        <div class="animated-med body-container">
          <transition mode="out-in" enter-active-class="fadeInUp" leave-active-class="fadeOutDown">
            <div
              v-if="loaded"
              class="animated-med title-y"
            >WE ARE PRODUCERS THAT EMPOWER VISIONARY FILMMAKERS</div>
          </transition>
          <transition mode="out-in" enter-active-class="fadeInUp" leave-active-class="fadeOutDown">
            <div
              v-if="loaded2"
              class="animated-med"
            >Rumble Riot Pictures produces compelling stories for audiences around the world. Our projects bring together the most sought after talent to deliver groundbreaking entertainment.</div>
          </transition>
          <transition mode="out-in" enter-active-class="fadeInUp" leave-active-class="fadeOutDown">
            <div
              v-if="loaded2"
              class="animated-med"
              style="display:flex; width:100%; align-items:center; padding-top:100px;"
            >
              <a target="_blank" href="https://www.facebook.com/RumbleRiot/" class="social-tag">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/rumbleriot/?hl=en"
                class="social-tag"
              >
                <i class="fab fa-instagram"></i>
              </a>
              <a
                target="_blank"
                href="https://twitter.com/rumbleriotpics?lang=en"
                class="social-tag"
              >
                <i class="fab fa-twitter"></i>
              </a>
            </div>
          </transition>
        </div>
      </div>
    </v-parallax>

    <div class="about-container"></div>
  </div>
</template>
<script>
export default {
  name: "about",
  data() {
    return {
      loaded: false,
      loaded2: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true;
    }, 300);
    setTimeout(() => {
      this.loaded2 = true;
    }, 500);
  },
  computed: {
    laxheight() {
      if (this.$mq == "sm") {
        return window.screen.height;
      } else {
        return window.screen.height;
      }
    }
  }
};
</script>
<style scoped>
a {
  color: #fff;
}
.social-tag {
  flex: 1;
  font-size: 50pt;
  transition: all 0.3s ease;
  opacity: 0.5;
  cursor: pointer;
}
.social-tag:hover {
  color: #fff;
  opacity: 1;
  transform: scale(1.1, 1.1);
}
.body-container {
  max-width: 1200px;
  height: 200px;
  width: 100%;
}
.title-y {
  font-size: 25pt;
  letter-spacing: 2px;
  margin-bottom: 20px;
}
.dots {
  height: 100%;
  width: 100%;
  left: 0;
  position: absolute;
  background: url("https://conductorproductions.com/wp-content/plugins/revslider/public/assets/assets/gridtile_3x3.png");
  background-color: #000000aa;
  background-repeat: repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.about-container {
  height: 0px;
  width: 100%;

  /* background: url("../../img/rumbleboys.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat; */
}
@media (max-width: 728px) {
  .body-container {
    height: 420px;
    padding: 15px;
  }
  .title-y {
    font-size: 19pt;
  }
  .about-container {
    height: 0;
  }
}
</style>